import { CommonTestIds } from '@/__e2e__/testIds/common';

export const ASPECT_RATIO_COEFFICIENT = 3.3;
export const DATA_TEST_ID = CommonTestIds.header.logoLink;
